<template>
    <div>
        <span>{{ $t('notification.formUpdated', {
            user: $_.get(activity, 'actorUser.name'),
            formName: $_.get(activity, 'payload.formName')
        }) }}</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "FormUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>

